export const actions = {
    CANCEL_COLLECT: 'cancel-collect',
    CANCEL_ORDER: 'cancel-order',
    COLLECT: 'collect',
    CONTACT: 'contact',
    DELIVERY: 'delivery',
    INVOICE: 'invoice',
    PAY: 'pay',
    RATE: 'rate'
}